import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Pages/Config"; // Adjust as needed

const BuyerNamechar = ({ buyerId }) => {
  const [initial, setInitial] = useState("");

  useEffect(() => {
    const fetchBuyer = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/get_user_by_id.php?id=${buyerId}`);
       if (res.data.success && res.data.data?.name) {
  const firstLetter = res.data.data.name.trim().charAt(0).toUpperCase();
  setInitial(firstLetter);
} else {
  setInitial("?");
}
      } catch (error) {
        console.error("Error fetching buyer name:", error);
        setInitial("?");
      }
    };

    if (buyerId) {
      fetchBuyer();
    }
  }, [buyerId]);

  return <span>{initial}</span>;
};

export default BuyerNamechar;
